import { Injectable } from "@angular/core";

import { from, of, EMPTY } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchSalesproposalsListData, fetchSalesproposalsListSuccess, fetchSalesproposalsListFailure, addSalesproposalData, addSalesproposalDataSuccess, addSalesproposalDataFailure, fetchSingleSalesproposalRecordData, fetchSingleSalesproposalRecordDataSuccess, fetchSingleSalesproposalRecordDataFailure, updateSalesproposalStatus, updateSalesproposalStatusSuccess, updateSalesproposalStatusFailure, fetchSalesproposalRecordComments, fetchSalesproposalRecordCommentsFailure, fetchSalesproposalRecordCommentsSuccess, fetchSalesproposalRecordRevisions, fetchSalesproposalRecordRevisionsSuccess, fetchSalesproposalRecordRevisionsFailure, fetchSalesproposalRecordholdunhold, fetchSalesproposalRecordholdunholdSuccess, fetchSalesproposalRecordholdunholdFailure, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, createRevisionRecordFailure, createSalesproposalCommentRecord, createSalesproposalCommentRecordSuccess, createSalesproposalCommentRecordFailure, fetchSalesproposalMembersList, fetchSalesproposalMembersListFailure, fetchSalesproposalMembersListSuccess, fetchSalesproposalCancelReasonsList, fetchSalesproposalCancelReasonsListSuccess, fetchSalesproposalCancelReasonsListFailure, cancelSalesproposalRecord, cancelSalesproposalRecordSuccess, cancelSalesproposalRecordFailure, fetchSalesproposalAttachments, fetchSalesproposalAttachmentsSuccess, fetchSalesproposalAttachmentsFailure, editSalesproposalData, editSalesproposalDataSuccess, editSalesproposalDataFailure, releaseSalesproposalRecord, releaseSalesproposalRecordSuccess, releaseSalesproposalRecordFailure, fetchSalesproposalFileAttachment, fetchSalesproposalFileAttachmentSuccess, fetchSalesproposalFileAttachmentFailure, createSalesproposalReviewCommentRecord, createSalesproposalReviewCommentRecordFailure, createSalesproposalReviewCommentRecordSuccess, deleteRevisionRecord, deleteRevisionRecordSuccess, deleteRevisionRecordFailure, filterSalesproposalsListData, filterSalesproposalsListSuccess } from "./salesproposal.actions";
import { SalesproposalService } from "../../core/services/salesproposal.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { TokenStorageService } from '../../core/services/token-storage.service';
import { ToastifyService } from "../../shared/toastify-service";
import { Router } from "@angular/router";
import { SalesproposalModel } from "../../core/models/salesproposal.models";
import { GenericService } from "../../core/services/generic.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { GlobalComponent } from "../../global-component";
import { collection, collectionData, Timestamp, query, where, and, or, onSnapshot, QueryConstraint, QueryCompositeFilterConstraint, orderBy } from '@angular/fire/firestore';
import { FiltersService } from "../../core/services/filters.service";


@Injectable()
export class SalesproposalEffects {

  currentuser: any;
  firbasebasecollname: string = 'vendors';
  subdomaincollname: string = 'subdomains';
  vendorguid!: string;

  // checkcondition(ref: any, tabId: number) {
  //   this.currentuser = this.tokenService.getUser();
  //   let isuservendor = this.genericService.getUserIsVendor();
  //   let activestateval = true;
  //   if(tabId == 6){
  //     activestateval = false;
  //   }
  //   let baseQuery = ref.where('activestate', '==', activestateval);

  //   if (!this.currentuser.usertype || !isuservendor) {
  //     baseQuery = baseQuery.where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
  //   }

  //   switch (tabId) {
  //     case 1:
  //       if (isuservendor) {
  //         if(this.currentuser.isprelimuser){

  //         }

  //         if(this.currentuser.isproductionuser){
  //           return or(and(where('jobstatus', 'in', ['accepted']), where('isprelimrequired', '==', false)),where('jobstatus', 'in', ['auroracompleted']))
  //         }
  //         return baseQuery.where('jobstatus', 'in', ['outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       } else {
  //         return baseQuery.where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked']).where('isinrevisionstate', '==', false);
  //       }
  //     case 2:
  //       return baseQuery.where('isinrevisionstate', '==', true).where('jobstatus', '==', 'accepted');
  //     case 3:
  //       return baseQuery.where('jobstatus', '==', 'hold');
  //     case 4:
  //       return baseQuery.where('jobstatus', 'in', ['auroraassigned', 'auroracompleted', 'productionassigned', 'productioncompleted', 'reviewassigned', 'reviewpassed', 'reviewfailed']);
  //     case 5:
  //       return baseQuery.where('jobstatus', '==', 'delivered');
  //     case 6:
  //       return baseQuery;
  //     default:
  //       return baseQuery;
  //   }
  // }

  async checkCondition(tabId: number) {
    this.currentuser = this.tokenService.getUser();
    const isuservendor = this.genericService.getUserIsVendor();
    const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/salesproposals`);
    let activestateval = true;
    if (tabId == 6) {
      activestateval = false;
    }

    const filterData: any = this.filtersService.getSalesProposalSelectedFilters()

    let baseQuery = and(where('activestate', '==', activestateval));

    // Adding Filter Queries to baseQuery
    if (filterData.clients && filterData.clients.length) {
      baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
    }

    if (filterData.jobtypes && filterData.jobtypes.length) {
      baseQuery = and(baseQuery, where("jobtype", "in", filterData.jobtypes))
    }

    if (filterData.states && filterData.states.length) {
      baseQuery = and(baseQuery, where("state", "in", filterData.states))
    }

    if (filterData.propertytypes && filterData.propertytypes.length) {
      baseQuery = and(baseQuery, where("propertytype", "in", filterData.propertytypes))
    }
    if (filterData.statuses && filterData.statuses.length) {
      baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
    }
    if (filterData.daterange && filterData.daterange.length) {
      let queryby = ""
      switch (tabId) {
        case 1:
          queryby = "createdAt"
          break
        case 2:
          queryby = "revisiondate"
          break
        case 3:
          queryby = "onholddate"
          break
        case 5:
          queryby = "deliverydate"
          break
        default:
          queryby = "createdAt"
      }
      let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
      let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))


      if (filterData.daterange.length === 2) {
        endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))

      }

      baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
    }


    const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
    let userRoleQuery: any = baseQuery;
    let memberQuery: QueryCompositeFilterConstraint | null = null;

    if (!this.currentuser.usertype || !isuservendor) {
      userRoleQuery = and(userRoleCondition, baseQuery) as QueryCompositeFilterConstraint;
    }

    switch (tabId) {
      case 1:
        if (this.currentuser.isprelimuser) {
          memberQuery = and(userRoleQuery, where('jobstatus', 'in', ['accepted']));
        }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(userRoleQuery, where('jobstatus', '==', 'auroracompleted')));
          } else {
            memberQuery = and(userRoleQuery, where('jobstatus', '==', 'auroracompleted'));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        if (!isuservendor) {
          return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
        }
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));

      case 2:
        return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', true), where('jobstatus', '==', 'accepted')), orderBy("revisiondate", "desc"));

      case 3:
        return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'hold')), orderBy("onholddate", "desc"));

      case 4:
        memberQuery = null;
        if (this.currentuser.isprelimuser) {
          memberQuery = or(and(where('jobstatus', 'in', ['auroracompleted', 'reviewfailed']), where('auroraassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['auroraassigned']), where('activeuserguid', '==', this.currentuser.guid)));
        }

        // if (this.currentuser.isproductionuser) {
        //   if (memberQuery) {
        //     memberQuery = or(memberQuery, or(and(where('jobstatus', 'in', ['productioncompleted', 'reviewfailed']),where('productionassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['productionassigned']), where('activeuserguid', '==', this.currentuser.guid))));
        //   } else {
        //     memberQuery = or(and(where('jobstatus', 'in', ['productioncompleted', 'reviewfailed']),where('productionassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['productionassigned', 'productioncompleted', 'reviewfailed']), where('activeuserguid', '==', this.currentuser.guid)));
        //   }
        // }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, or(and(where('jobstatus', 'in', ['reviewpassed', 'reviewfailed']), where('qcassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['reviewassigned']), where('activeuserguid', '==', this.currentuser.guid))));
          } else {
            memberQuery = or(and(where('jobstatus', 'in', ['reviewpassed', 'reviewfailed']), where('qcassigneduserguid', '==', this.currentuser.guid)), and(userRoleQuery, where('jobstatus', 'in', ['reviewassigned', 'reviewpassed', 'reviewfailed']), where('activeuserguid', '==', this.currentuser.guid)));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("createdAt", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['auroraassigned', 'auroracompleted', 'reviewassigned', 'reviewpassed', 'reviewfailed'])), orderBy("createdAt", "desc"));

      case 5:
        memberQuery = null;
        if (this.currentuser.isprelimuser) {
          memberQuery = and(where('jobstatus', 'in', ['delivered']), where('auroraassigneduserguid', '==', this.currentuser.guid));
        }

        // if (this.currentuser.isproductionuser) {
        //   if (memberQuery) {
        //     memberQuery = or(memberQuery, and(where('jobstatus', 'in', ['delivered']),where('productionassigneduserguid', '==', this.currentuser.guid)));
        //   } else {
        //     memberQuery = and(where('jobstatus', 'in', ['delivered']),where('productionassigneduserguid', '==', this.currentuser.guid));
        //   }
        // }

        if (this.currentuser.isqcuser) {
          if (memberQuery) {
            memberQuery = or(memberQuery, and(where('jobstatus', 'in', ['delivered']), where('qcassigneduserguid', '==', this.currentuser.guid)));
          } else {
            memberQuery = and(where('jobstatus', 'in', ['delivered']), where('qcassigneduserguid', '==', this.currentuser.guid));
          }
        }

        if (memberQuery) {
          return query(vendorCollection, memberQuery, orderBy("deliverydate", "desc"));
        }

        return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

      case 6:
        return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

      default:
        console.log('Invalid tabId:', tabId);
        return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
    }
  }


  /**
   * FOR VENDOR
   */
  // Salesproposal Fresh List Effect Of Vendor
  fetchSalesproposalData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalsListData),
      mergeMap(({ tabId }) =>
        from(this.checkCondition(tabId)).pipe(
          mergeMap(condition =>
            collectionData(condition).pipe(
              map((docs: any) => {
                console.log("docs", docs);
                console.log("tabId", tabId);
                const salesproposals = docs.map((doc: SalesproposalModel) => doc);
                return fetchSalesproposalsListSuccess({ Salesproposals: salesproposals, tabid: tabId });
              }),
              catchError((error) =>
                of(fetchSalesproposalsListFailure({ error, tabid: tabId }))
              )
            )
          )
        )
      )
    )
  );

  // Create Salesproposal Record
  addSalesproposalData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addSalesproposalData),
      mergeMap(({ postdata }) =>
        this.salesproposalService.addSalesproposalsData(postdata).pipe(
          map((salesproposalrecord) => addSalesproposalDataSuccess(salesproposalrecord)),
          catchError((error) => of(addSalesproposalDataFailure({ error })))
        )
      ),
    ),
  );

  addSalesproposalDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addSalesproposalDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order created successfully");
        })
      ),
    { dispatch: false }
  );

  addSalesproposalDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(addSalesproposalDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Salesproposal Record
  fetchSingleSalesproposalRecordData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSingleSalesproposalRecordData),
      mergeMap(({ recordguid }) =>
        this.salesproposalService.getSalesproposalsRecordData(recordguid).pipe(
          map((salesproposalrecord) => fetchSingleSalesproposalRecordDataSuccess({ salesproposalrecord })),
          catchError((error) => of(fetchSingleSalesproposalRecordDataFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Salesproposal Record
  updateSalesproposalStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateSalesproposalStatus),
      mergeMap(({ recordguid, postdata }) =>
        this.salesproposalService.updateSalesproposalStatus(recordguid, postdata).pipe(
          map(() => updateSalesproposalStatusSuccess()),
          catchError((error) => of(updateSalesproposalStatusFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Salesproposal Record
  updateSalesproposalStatusSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateSalesproposalStatusSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  updateSalesproposalStatusFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateSalesproposalStatusFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Salesproposal Comments Record
  fetchSalesproposalRecordComments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalRecordComments),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('salesproposalcomments', recordguid, 'createdAt:DESC').pipe(
          map((comments) => fetchSalesproposalRecordCommentsSuccess({ comments: comments })),
          catchError((error) => of(fetchSalesproposalRecordCommentsFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalRecordCommentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalRecordCommentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Salesproposal Revisions Record
  fetchSalesproposalRecordRevisions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalRecordRevisions),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('salesproposalrevisionjobs', recordguid, 'createdAt:DESC').pipe(
          map((revisions) => fetchSalesproposalRecordRevisionsSuccess({ revisions: revisions })),
          catchError((error) => of(fetchSalesproposalRecordRevisionsFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalRecordRevisionsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalRecordRevisionsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Fetch Salesproposal Hold/Unhold Record
  fetchSalesproposalRecordholdunhold$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalRecordholdunhold),
      mergeMap(({ recordguid }) =>
        this.commonService.fetchRecords('salesproposalholdjobs', recordguid, 'createdAt:DESC').pipe(
          map((holdunholdrecords) => fetchSalesproposalRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
          catchError((error) => of(fetchSalesproposalRecordholdunholdFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalRecordholdunholdFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalRecordholdunholdFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createHoldRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createHoldRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('salesproposalholdjobs', postdata).pipe(
          map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
          catchError((error) => of(createHoldRecordFailure({ error })))
        )
      ),
    ),
  );

  createHoldRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createHoldRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createHoldRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // HOLD RECORD CREATE
  createRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createRevisionRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('salesproposalrevisionjobs', postdata).pipe(
          map((revisionrecord) => createRevisionRecordSuccess({ revisionrecord })),
          catchError((error) => of(createRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  createRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.holdsuccess);
        })
      ),
    { dispatch: false }
  );

  createRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createRevisionRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // COMMENT CREATE
  createSalesproposalCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createSalesproposalCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('salesproposalcomments', postdata).pipe(
          map((comment) => createSalesproposalCommentRecordSuccess({ comment })),
          catchError((error) => of(createSalesproposalCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  // Fetch Salesproposal Comments Record
  fetchSalesproposalMembersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalMembersList),
      mergeMap(({ recordguid }) =>
        this.salesproposalService.getSalesproposalsMembersList(recordguid).pipe(
          map((list) => fetchSalesproposalMembersListSuccess({ memberslist: list })),
          catchError((error) => of(fetchSalesproposalMembersListFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalMembersListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalMembersListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  createSalesproposalCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createSalesproposalCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH CANCEL REASONS FROM FIREBASE
  fetchSalesproposalCancelReasonsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalCancelReasonsList),
      mergeMap(() =>
        this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
          .valueChanges().pipe(
            map((docs: any) => {
              console.log(":docs", docs)
              return fetchSalesproposalCancelReasonsListSuccess({ reasons: docs });
            }),
            catchError((error) =>
              of(fetchSalesproposalCancelReasonsListFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchSalesproposalCancelReasonsListFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalCancelReasonsListFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  // CANCEL PLANSET PROJECT
  cancelSalesproposalRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cancelSalesproposalRecord),
      mergeMap(({ postdata }) =>
        this.salesproposalService.cancelSalesproposalProject(postdata).pipe(
          map(() => cancelSalesproposalRecordSuccess()),
          catchError((error) => of(cancelSalesproposalRecordFailure({ error })))
        )
      ),
    ),
  );

  cancelSalesproposalRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelSalesproposalRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
        })
      ),
    { dispatch: false }
  );

  cancelSalesproposalRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(cancelSalesproposalRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PLANSET RECORD
  fetchSalesproposalAttachments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalAttachments),
      mergeMap(({ jobguid }) =>
        this.salesproposalService.getSalesproposalsAttachments(jobguid).pipe(
          map((attachments) => fetchSalesproposalAttachmentsSuccess({ attachments })),
          catchError((error) => of(fetchSalesproposalAttachmentsFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalAttachmentsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalAttachmentsFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // Create Salesproposal Record
  editSalesproposalData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editSalesproposalData),
      mergeMap(({ postdata, recordId }) =>
        this.salesproposalService.editSalesproposalsData(postdata, recordId).pipe(
          map((salesproposalrecord) => editSalesproposalDataSuccess(salesproposalrecord)),
          catchError((error) => of(editSalesproposalDataFailure({ error })))
        )
      ),
    ),
  );

  editSalesproposalDataSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editSalesproposalDataSuccess),
        tap((user: any) => {
          this.toastifyService.showSuccessMessage("Order updated successfully");
        })
      ),
    { dispatch: false }
  );

  editSalesproposalDataFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(editSalesproposalDataFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * RELEASE PLANSET RECORD
   */
  releaseSalesproposalRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(releaseSalesproposalRecord),
      mergeMap(({ recordguid, postdata }) =>
        this.salesproposalService.releaserecord(recordguid, postdata).pipe(
          map(() => releaseSalesproposalRecordSuccess()),
          catchError((error) => of(releaseSalesproposalRecordFailure({ error })))
        )
      ),
    ),
  );

  releaseSalesproposalRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releaseSalesproposalRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Record released successfully");
          // this.router.navigate(['../']);
        })
      ),
    { dispatch: false }
  );

  releaseSalesproposalRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releaseSalesproposalRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  // FETCH ATTACHMENTS OF PLANSET RECORD
  fetchSalesproposalFileAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSalesproposalFileAttachment),
      mergeMap(({ jobguid }) =>
        this.salesproposalService.getSalesproposalFile(jobguid).pipe(
          map((attachments) => fetchSalesproposalFileAttachmentSuccess({ attachments })),
          catchError((error) => of(fetchSalesproposalFileAttachmentFailure({ error })))
        )
      ),
    ),
  );

  fetchSalesproposalFileAttachmentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSalesproposalFileAttachmentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  //REVIEW COMMENT CREATE
  // COMMENT CREATE
  createSalesproposalReviewCommentRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createSalesproposalReviewCommentRecord),
      mergeMap(({ postdata }) =>
        this.commonService.createRecords('salesproposalcomments', postdata).pipe(
          map((comment) => createSalesproposalReviewCommentRecordSuccess({ comment })),
          catchError((error) => of(createSalesproposalReviewCommentRecordFailure({ error })))
        )
      ),
    ),
  );

  createSalesproposalReviewCommentRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createSalesproposalReviewCommentRecordFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );

  /**
   * REVISION DELETE
   */
  deleteRevisionRecord$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteRevisionRecord),
      mergeMap(({ id }) =>
        this.salesproposalService.deleterevision(id).pipe(
          map(() => deleteRevisionRecordSuccess()),
          catchError((error) => of(deleteRevisionRecordFailure({ error })))
        )
      ),
    ),
  );

  deleteRevisionRecordSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordSuccess),
        tap(() => {
          this.toastifyService.showSuccessMessage("Revision deleted and moved to delivered successfully");
        })
      ),
    { dispatch: false }
  );

  deleteRevisionRecordFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteRevisionRecordFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
  );



  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private tokenService: TokenStorageService,
    private salesproposalService: SalesproposalService,
    private toastifyService: ToastifyService,
    private router: Router,
    private genericService: GenericService,
    private commonService: CommonAPIService,
    private filtersService: FiltersService
  ) {
  }
}